import { ComuniList } from './useComuniLists';

export const filterListsByName = (lists: ComuniList[], query: string): ComuniList[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return lists;
  return lists.filter((list) => list.name.toLowerCase().includes(normalized));
};

export const partitionUploadAndCombo = (lists: ComuniList[]): { uploads: ComuniList[]; combos: ComuniList[] } => {
  const uploads: ComuniList[] = [];
  const combos: ComuniList[] = [];

  for (const list of lists) {
    if (list.isUpload) uploads.push(list);
    else if (list.isCombo) combos.push(list);
  }

  return { uploads, combos };
};
